import { render, staticRenderFns } from "./PCFooter.vue?vue&type=template&id=10a42276&scoped=true&"
import script from "./PCFooter.vue?vue&type=script&lang=js&"
export * from "./PCFooter.vue?vue&type=script&lang=js&"
import style0 from "./PCFooter.vue?vue&type=style&index=0&id=10a42276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a42276",
  null
  
)

export default component.exports